import Vue from 'vue'
import Vuex from 'vuex'
import { DIALOG_OPTION } from './mutation-types'
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    dialog: {
      dialogTableVisible: false,
      type: '',
      data: {},
    }, //模态框
    base_info: {}, //页面数据
    user_info: {}, //用户信息
    showPwIframe: false, //完美登录框
    activePage: 'HomeMain', //当前页面
    tag_list: [], //标签
    user_prize: [], //我的奖品
  },
  getters: {},
  mutations: {
    [DIALOG_OPTION](state, options) {
      state.dialog = options
    },
  },
})
